import { defineEvents, SHARED_EVENTS } from '@3plearning/mx-teacher-analytics';

const ASSIGNMENT = 'assignment';
const FILTERS = 'filters';
const GRID = 'grid';
const PREVIEW = 'preview';
const UI = 'ui';

const appEvents = defineEvents({
  ...SHARED_EVENTS,
  'assignment.confirmation': { group: ASSIGNMENT, props: {} },
  'assignment.history-view': { group: ASSIGNMENT, props: {} },
  'filter.class-changed': { group: FILTERS, props: {} },
  'filter.group-changed': { group: FILTERS, props: {} },
  'filter.course-changed': { group: FILTERS, props: {} },
  'filter.applied': { group: FILTERS, props: {} },
  'grid.checkbox-click': { group: GRID, props: {} },
  'grid.select-all': { group: GRID, props: {} },
  'activity.preview': { group: PREVIEW, props: {} },
  'ui.view-toggle': { group: UI, props: {} }
});

export default appEvents;
